import styled from 'styled-components';
import { widthResize, widthFull, heightHeader, primary, text, textMuted, boxShadow, border, bgLight } from '../Resources/Theme';

const Header = styled.header`
  position: fixed;
  height: ${heightHeader};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  left: ${props => props.resize ? widthResize : widthFull};
  box-shadow: none;
  border-bottom: 1px solid ${border};
  background: #fff;
  transition: .5s;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 4;
  
  @media (max-width: 992px) {
    left: 0;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

Header.Left = styled.div`
  height: ${heightHeader};
  display: none;
  align-items: center;
  color: ${primary};

  @media (max-width: 992px) {
    width: 33%;
    display: flex;
  }
`;

Header.Brand = styled.div`
  display: none;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    align-self: center;
    justify-content: center;
    display: flex;
  }
`;

Header.Brand.Logo = styled.img`
  @media (max-width: 992px) {
    max-height: 48px;
  }
`;

Header.Right = styled.div`
  height: ${heightHeader};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
  max-height: ${heightHeader};
  gap: 4px;

  @media (max-width: 992px) {
    width: 100%;
    margin-left: 0;
  }
`;

Header.Right.Icon = styled.div`
  height: 40px;
  min-width: 40px;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  color: ${textMuted};
  cursor: pointer;
  border-radius: 8px;

  strong {
    color: ${text};
    font-weight: 600;
  }

  &:hover {
    background-color: ${bgLight};
    color: ${primary};
  }

  @media (max-width: 992px) {
    min-width: 36px;
    padding: 0 6px;
  }
`;

Header.Right.Profile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${text};
  padding: 8px 0 4px;

  strong {
    margin-top: 8px;
    font-size: 0.9rem;
  }

  span {
    font-size: 0.75rem;
    color: ${textMuted};
  }
`;

Header.Right.Image = styled.img`
  border-radius: 50%;
  max-height: ${props => props.maxHeight ? props.maxHeight : '32px'};
  box-shadow: ${boxShadow};
  border: 2px solid ${border};
  object-fit: cover;
`;

export default Header;
